"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var nyancatEgg = {
    name: "nyancat",
    enabled: false,
    trigger: {
        type: "keys",
        keystrokes: ["n", "y", "a", "n", "c", "a", "t"],
        captureOnInputs: false
    },
    onStart: function () {
        var data = "https://i.imgur.com/3kI22fU.gif";
        var shock = document.createElement("div");
        var img = new Image();
        img.src = data;
        img.style.width = "230px";
        img.style.height = "150px";
        img.style.transition = "6s all linear";
        img.style.position = "fixed";
        img.style.left = "-400px";
        img.style.bottom = "calc(-50% + 340px)";
        img.style.zIndex = "999999";
        document.body.appendChild(img);
        // window.setTimeout(function(){
        //   img.style.left = 'calc(50% - 200px)'
        // },50)
        window.setTimeout(function () {
            img.style.left = "calc(100% + 500px)";
        }, 50);
        window.setTimeout(function () {
            img.parentNode.removeChild(img);
        }, 6000);
    },
};
exports.default = nyancatEgg;
